import { NodeCategory } from 'src/containers/ProjectDiagram/constants/categories';
import { ModelConceptClass } from 'src/containers/ProjectDiagram/types/data';
import { generateDetachedKey } from 'src/containers/ProjectDiagram/utils/detachedKey';

export const getModelConceptClassKey = (value: string) =>
  `${NodeCategory.MODEL_CONCEPT_CLASS}-${value}`;

export const getModelConceptClassValue = (key: string) =>
  key.replace(new RegExp(`^${NodeCategory.MODEL_CONCEPT_CLASS}-`), '');

export const getOrCreateModelConceptClassKey = (iri?: string) =>
  iri ? getModelConceptClassKey(iri) : generateDetachedKey();

export const createModelConceptClass = ({
  value,
}: {
  value: string;
}): ModelConceptClass => ({
  key: getModelConceptClassKey(value),
  value,
  category: NodeCategory.MODEL_CONCEPT_CLASS,
  isAttributesOpen: false,
});
